import * as React from 'react'
import { connect } from 'react-redux'
//import { ApplicationState } from '../../store'
import {
    Row, Col, Spinner, InputGroup, Input, InputGroupAddon, InputGroupText, InputGroupButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button
} from 'reactstrap';
// @ts-ignore
import DatePicker from 'reactstrap-date-picker';

interface IState {
    modal: boolean
    term : string
    dtFrom : string
    dtFromFormatted : string
    dtTo : string
    dtToFormatted : string
}
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    term:string
    loading: boolean
    dtFrom : string
    dtTo : string
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    onSearch: any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch;


class ListSearch extends React.Component<AllProps, IState> {

    /**
     *
     */
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modal: false,
            term : this.props.term,
            dtFrom : '',
            dtFromFormatted:'',
            dtTo : '',
            dtToFormatted:''
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onEnterPressed = this.onEnterPressed.bind(this);
        this.onDtFromChange = this.onDtFromChange.bind(this);
        this.onDtToChange = this.onDtToChange.bind(this);
    }
    public componentDidMount() {
    }
    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.term !== this.props.term){
            this.setState({term:this.props.term}); 
        }
    }

    onInputChange(e:any) {
        this.setState({ term: e.target.value });
    }
    onEnterPressed(e:any){
        var code = e.keyCode || e.which;
        if(code === 13) { //13 is the enter keycode
            //console.log("Entered");
            this.props.onSearch(this.state);
        } 
    }
    
    onDtFromChange = (value : any, formattedValue: any) => {
        this.setState({ dtFrom: value, dtFromFormatted : formattedValue});
    }
    onDtToChange = (value : any, formattedValue: any) => {
        this.setState({ dtTo: value, dtToFormatted : formattedValue});
    }

    public render() {
        return (
            <React.Fragment>
                <Row>
                    <Col lg="10" >
                        <InputGroup>
                            <Input placeholder="Search by course Id, reference no and user name" value={this.state.term} onChange={this.onInputChange} onKeyPress={this.onEnterPressed.bind(this)}/>
                            <InputGroupAddon addonType="append">
                                <InputGroupText>From</InputGroupText>
                                <DatePicker id = "dtFrom" dateFormat={"DD/MM/YYYY"} 
                                    onChange= {(v:any,f:any) => this.onDtFromChange(v, f)}
                                    value={this.state.dtFrom} 
                                    showClearButton={false}/>  
                            </InputGroupAddon>
                            <InputGroupAddon addonType="append">
                                <InputGroupText>Until</InputGroupText>
                                <DatePicker id = "dtTo" dateFormat={"DD/MM/YYYY"} 
                                    onChange= {(v:any,f:any) => this.onDtToChange(v, f)}
                                    value={this.state.dtTo} 
                                    showClearButton={false}/>  
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>
                    <Col lg="2" >
                        <Button color="success" onClick={this.props.onSearch.bind(this, this.state)} block>
                            <i className="fas fa-search mr-1"></i>
                            &nbsp;&nbsp;Search&nbsp;&nbsp;</Button>
                    </Col>
                </Row>
                {/* {this.props.dtFrom ? new Date(this.props.dtFrom).toISOString() : ''} */}
            </React.Fragment>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = () => ({
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps
)(ListSearch)